import axios from "axios";
import { API } from "../App";

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

export async function isPushSupported() {
  return 'serviceWorker' in navigator && 'PushManager' in window;
}

export async function registerSW() {
  if (!('serviceWorker' in navigator)) return null;
  try {
    const reg = await navigator.serviceWorker.register('/sw.js');
    return reg;
  } catch (e) {
    console.warn('SW register failed', e);
    return null;
  }
}

export async function requestPushPermissionAndSubscribe(token) {
  if (!await isPushSupported()) return { ok: false, reason: 'unsupported' };
  const reg = await registerSW();
  if (!reg) return { ok: false, reason: 'sw_failed' };

  const perm = await Notification.requestPermission();
  if (perm !== 'granted') return { ok: false, reason: 'denied' };

  const { data } = await axios.get(`${API}/push/vapid-public-key`);
  const publicKey = data.public_key;
  if (!publicKey) return { ok: false, reason: 'no_vapid' };

  let subscription = await reg.pushManager.getSubscription();
  if (!subscription) {
    subscription = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey)
    });
  }
  const raw = subscription.toJSON();
  await axios.post(`${API}/push/subscribe`, {
    endpoint: raw.endpoint,
    keys: raw.keys
  }, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
  localStorage.setItem('gentleflow_push_enabled', '1');
  return { ok: true };
}

export function pushPermissionStatus() {
  if (typeof Notification === 'undefined') return 'unsupported';
  return Notification.permission; // 'default' | 'granted' | 'denied'
}
